export enum AuthErrors {
  RefreshTokenError = 1,
  LostUserDetails = 2,
  PermissionsMissing = 3,
  ForceLogout = 4,
  FailedRedirect = 5,
  /**
   * The CATCH-ALL refusal: anything the API does not name specifically. A closed account, a leaver, a
   * record linked to a different Microsoft account, an alias-only sign-in, or a configuration fault.
   *
   * The name is historic and narrower than the meaning — it is frontend-only and renaming it would
   * touch every call site for no behavioural gain. Its MESSAGE was softened in #1557 so it no longer
   * asserts "your account is not active", which was true for only one of the cases it catches.
   */
  UserNotActive = 6,
  /**
   * More than one Vision staff record carries this person's email address, so sign-in cannot tell
   * which one is theirs and refuses rather than guessing (#1557).
   *
   * Distinct from UserNotActive on purpose. Both records are usually ACTIVE = 1, so the old shared
   * message told these people the opposite of the truth — they contacted support saying they had
   * been deactivated, support saw an active record, and nobody was any the wiser. Roughly 29 people
   * are in this state — 25 sharing an address and 4 sharing a Microsoft account, both of which reach
   * this message; the fix is a data clean-up (#1558), not something they can do themselves.
   */
  DuplicateAccounts = 7,
}
